export function normalizePricelistCaseFileNotes(value: string): string | null {
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
}

export function pricelistCaseFileNotesChanged(
  current: string | null,
  draft: string,
): boolean {
  return normalizePricelistCaseFileNotes(draft) !== current;
}

export function adoptPricelistCaseFileNotesFromServer(
  serverNotes: string | null,
  syncedNotes: string | null,
  notesDraft: string,
): { syncedNotes: string | null; notesDraft: string } | null {
  if (serverNotes === syncedNotes) return null;
  return {
    syncedNotes: serverNotes,
    notesDraft: pricelistCaseFileNotesChanged(syncedNotes, notesDraft)
      ? notesDraft
      : (serverNotes ?? ''),
  };
}

export function pricelistCaseFileNameClassName(deprecated: boolean): string {
  return deprecated ? 'truncate line-through' : 'truncate';
}

export function fileUpdateFailureMessage(
  error: unknown,
  fallback: string,
): string {
  return error instanceof Error ? error.message : fallback;
}

export function pricelistCaseFileAddedByName(
  userNameById: ReadonlyMap<string, string>,
  addedByUserId: string | null,
): string {
  if (addedByUserId === null) return '—';
  return userNameById.get(addedByUserId) ?? '—';
}

const ADDED_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
};

const addedDateFormatters = new Map<string, Intl.DateTimeFormat>();

function addedDateFormatter(locale: string): Intl.DateTimeFormat {
  const cached = addedDateFormatters.get(locale);
  if (cached) return cached;
  const formatter = new Intl.DateTimeFormat(locale, ADDED_DATE_OPTIONS);
  addedDateFormatters.set(locale, formatter);
  return formatter;
}

export function formatPricelistCaseFileAddedDate(
  addedAt: Date | string,
  locale: string,
): string {
  const date = typeof addedAt === 'string' ? new Date(addedAt) : addedAt;
  return addedDateFormatter(locale).format(date);
}

export function adjacentPricelistCaseFileDocumentId(
  documentIds: readonly string[],
  selectedDocumentId: string | undefined,
  direction: -1 | 1,
): string | undefined {
  if (documentIds.length === 0) return undefined;
  const currentIndex = selectedDocumentId
    ? documentIds.indexOf(selectedDocumentId)
    : -1;
  if (currentIndex === -1) {
    return direction === 1
      ? documentIds[0]
      : documentIds[documentIds.length - 1];
  }
  const nextIndex = currentIndex + direction;
  if (nextIndex < 0 || nextIndex >= documentIds.length) {
    return documentIds[currentIndex];
  }
  return documentIds[nextIndex];
}

export function nextPricelistCaseFileDocumentIdForKey(
  documentIds: readonly string[],
  selectedDocumentId: string | undefined,
  focusedDocumentId: string,
  key: string,
): string | undefined {
  if (key === 'Enter' || key === ' ') return focusedDocumentId;
  if (key === 'ArrowDown') {
    return adjacentPricelistCaseFileDocumentId(
      documentIds,
      selectedDocumentId,
      1,
    );
  }
  if (key === 'ArrowUp') {
    return adjacentPricelistCaseFileDocumentId(
      documentIds,
      selectedDocumentId,
      -1,
    );
  }
  return undefined;
}
